import { Event } from '../models/Event';
import { Pass } from '../models/Pass';

export function isInternalEmail(email: string): boolean {
  return /@ti8m\.(ch|com)$/.test(email);
}

export function isInternalPass(pass: Pass): boolean {
  return (pass.customFields?.ti8m_passtype?.Name === 'internal') ?? false;
}

export function isAcademyEvent(event: Event): boolean {
  return (event.customFields?.ti8m_eventtypeid.Name === 'Academy') ?? false;
}

export function isOnlineEvent(event: Event): boolean {
  if (!event.building) {
    return false;
  }

  return event.building?.name.search(/online/i) >= 0;
}
